import React, { useEffect, useState } from "react";
import BackendHeader from "../component/BackendHeader";
import axiosInstance from "../axiosInstance";
import { fetchChatPermissions } from "../libs/customerCreatePermission";
import TradePortalClient from "../components/TradePortalClient";
import "../css/adminOmnichannel.css";

const AdminOmnichannel = () => {
  const [chatPerm, setChatPerm] = useState({ loaded: false, canView: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const perm = await fetchChatPermissions(axiosInstance);
      if (!cancelled) {
        setChatPerm({ loaded: true, canView: Boolean(perm?.canView) });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="admin-omnichannel-shell">
      <BackendHeader />
      {chatPerm.loaded && !chatPerm.canView ? (
        <div className="container-fluid py-4">
          <div className="alert alert-warning mb-0">
            Bạn không có quyền truy cập màn hình này.
          </div>
        </div>
      ) : (
        <div className="admin-omnichannel-portal-slot">
          <div id="trade_portal_root" />
          {chatPerm.loaded && chatPerm.canView ? <TradePortalClient /> : null}
        </div>
      )}
    </div>
  );
};

export default AdminOmnichannel;
